export const ListQueryKey = 'assetsTranss';
export const DetailQueryKey = 'assetsTrans';

export const Urls = {
  selectUrl: '/assetTransfersRegistration/list',
  updateUrl: '/assetTransfersRegistration/update',
  deleteUrl: '/assetTransfersRegistration/delete',
  createUrl: '/assetTransfersRegistration/create',
  detailUrl: '/assetTransfersRegistration/detail',
};
